export const WIDTH = 586;
export const HEIGHT = 344;
export const TITLE_WIDTH = 96;
export const TITLE_HEIGHT = 46;
export const SUBTITLE_WIDTH = 141;
export const SUBTITLE_HEIGHT = 43;
export const TEXT_WIDTH = 245.08;
export const TEXT_HEIGHT = 22.6;
